import { manageErrorLogs } from "../../helpers/commonFunction";
import {
  clearTables,
  checkTablesInDB,
  safeTransaction,
} from "../../helpers/db";
import { updateUserState } from "./userSlice";

export const insertUserDetailsDataInDB = async (
  data,
  isFresh = false,
  dispatch
) => {
  try {
    const tables = ["userData", "lastAPICallTime", "systemLogs"];
    await safeTransaction(tables, async (tx) => {
      const userDataTable = tx.table(tables[0]);
      const lastAPICallTimeTable = tx.table(tables[1]);

      if (isFresh) {
        await clearTables(tx, tables);
        await userDataTable.put(data);
        localStorage.setItem("token", JSON.stringify(data?.token || ""));
        await lastAPICallTimeTable.add({
          call: 0,
          time: new Date(),
        });
      } else {
        const userData = await userDataTable.toArray();
        if (
          Array.isArray(userData) &&
          userData?.length > 0 &&
          userData[0]?.id
        ) {
          const newUserData = { ...userData[0] };
          await userDataTable.put(newUserData);
          await dispatch(updateUserState(newUserData));
        }
      }
    });
  } catch (error) {
    manageErrorLogs(error);
    return null;
  }
};

export const updateUserTableDataInDB = async (data) => {
  try {
    const tables = ["userData"];
    checkTablesInDB(tables);
    await safeTransaction(tables, async (tx) => {
      const userDataTable = tx.table(tables[0]);
      await userDataTable.update(data?.id, data);
    });
  } catch (error) {
    manageErrorLogs(error);
    return null;
  }
};

export const updateNewUserSessionInDB = async (token, refreshToken) => {
  try {
    const tables = ["userData"];
    await safeTransaction(tables, async (tx) => {
      const userDataTable = tx.table(tables[0]);
      const userData = await userDataTable.toArray();
      const newUserData =
        Array.isArray(userData) && userData?.length > 0
          ? { ...userData[0] }
          : JSON.parse(localStorage.getItem("user"));

      if (newUserData?.id) {
        const reqObj = {
          ...newUserData,
          token: token,
          refresh_token: refreshToken,
        };
        localStorage.setItem("user", JSON.stringify(reqObj));
        await userDataTable.put(reqObj);
      }
    });
  } catch (error) {
    manageErrorLogs(error);
    return null;
  }
};
